import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PrivilegePage from './PrivilegePage';

export const prefix = 'bm-p-privilege';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PrivilegePage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
